/** Activity log entity types (API source of truth). */
export enum ActivityLogEntityType {
  Branch = "BRANCH",
  Group = "GROUP",
  Ministry = "MINISTRY",
  IncomeCategory = "INCOME_CATEGORY",
  ExpenseCategory = "EXPENSE_CATEGORY",
  Member = "MEMBER",
  MemberRelationship = "MEMBER_RELATIONSHIP",
  FinanceTransaction = "FINANCE_TRANSACTION",
  CustomField = "CUSTOM_FIELD",
  User = "USER",
  WorkspaceInvitation = "WORKSPACE_INVITATION",
  Budget = "BUDGET",
  BudgetLine = "BUDGET_LINE",
}

/** Activity log action types (API source of truth). */
export enum ActivityLogActionType {
  Created = "CREATED",
  Updated = "UPDATED",
  Deleted = "DELETED",
  Enabled = "ENABLED",
  Disabled = "DISABLED",
  StatusChanged = "STATUS_CHANGED",
  Invited = "INVITED",
  AcceptedInvite = "ACCEPTED_INVITE",
  DeclinedInvite = "DECLINED_INVITE",
}
